<template>
  <div >
    <b-row align-h="center">
      <b-col sm="12">
        <p >
          Performance of this config in the using the latest version of the tags associated to the horses.
          <br>
          3 datasets are evaluated (minimum) per tag version
        </p>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col sm="auto">
        <table class="table" v-if="dataLoaded">
          <thead >
            <tr>
              <th scope="col">Dataset</th>
              <th scope="col">Win%</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dataset in successStats.datasets">
              <td>{{dataset}}</td>
              <td>{{getSuccessForDataset(dataset)}}</td>
              <td>
                <b-button v-if="!evaluationsTriggered[dataset]" @click="activeDatasets.push(dataset)">
                  <span v-if="!evaluationTriggersInProgress[dataset]">Trigger</span>
                  <b-spinner v-if="evaluationTriggersInProgress[dataset]" variant="success" label="Spinning"></b-spinner>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="dataLoaded">
          <b-button v-if="Object.keys(evaluationTriggersInProgress).length === 0" @click="activeDatasets = successStats.datasets">
            <span v-if="Object.keys(evaluationTriggersInProgress).length === 0">Trigger All</span>
            <b-spinner v-if="Object.keys(evaluationTriggersInProgress).length > 0" variant="success" label="Spinning"></b-spinner>
          </b-button>
        </div>
        <div>
          <b-row class="my-1" v-if="activeDatasets.length > 0" >
            <b-col sm="8">
              <b-form-input class="passwordInput" v-model="password" type="password" placeholder="Please enter password"></b-form-input>
            </b-col>
            <b-col sm="4">
              <b-button v-on:click="triggerEvaluation">Confirm</b-button>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showAlert">
            <b-col sm="12">
              <b-alert show variant="danger">Password incorrect</b-alert>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SuccessByDatasetForTagVersion from '../models/SuccessByDatasetForTagVersion'
import * as TasksClient from '../clients/TasksClient'
export default {
  name: 'PredictionConfigPerformanceTable',
  props: [],
  data () {
    return {
      title: 'PredictionConfigPerformanceTable',
      dataLoaded: false,
      successStats: {},
      configName: "",
      evaluationTriggersInProgress: {},
      evaluationsTriggered: {},
      showPasswordInput: true,
      password:"",
      showAlert: false,
      activeDatasets: []
    }
  },
  methods: {
    copyDatasetNumber (number) {
      const el = document.createElement('textarea');
     el.value = number;
     el.setAttribute('readonly', '');
     el.style.position = 'absolute';
     el.style.left = '-9999px';
     document.body.appendChild(el);
     el.select();
     document.execCommand('copy');
     document.body.removeChild(el);
   },
    loadTable: function()  {
      this.evaluationTriggersInProgress = {}
      this.evaluationsTriggered = {}
      this.configName = this.$route.params.configId
      this.dataLoaded = false
      var successByDatasetForTagVersion = new SuccessByDatasetForTagVersion()
      return successByDatasetForTagVersion.loadForPredictionConfig(this.configName)
      .then(response => {
        console.log(response)
        this.successStats = response
        this.dataLoaded = true
      })
    },
    getSuccessForDataset: function(dataset) {
      if (this.successStats.evaluations.length > 0) {
        return this.successStats.evaluations[0].datasets[dataset]
      }else {
        return ""
      }
    },
    triggerEvaluation: async function() {
      for (var dataset of this.activeDatasets) {
        try {
          this.evaluationTriggersInProgress[dataset] = true
          console.log(this.configName)
          await TasksClient.triggerEvaluation(dataset, this.configName, this.password)
          this.evaluationTriggersInProgress[dataset] = false
          this.evaluationsTriggered[dataset] = true
          this.activeDatasets = []
          this.showAlert = false
        }catch (err) {
          if (err.response.status === 403) {
            this.showAlert = true
            this.evaluationTriggersInProgress[tdataset] = false
            this.evaluationsTriggered[dataset] = false
          }
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === "PredictionConfig")   this.loadTable (this.tagVersion)
    }
  },
  activated () {
  },
  mounted () {
    this.loadTable (this.tagVersion)

  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}
p {
  color: #FFFFFF96
}
</style>
